export default __webpack_public_path__ + "static/about-byus-main-7059fff84fb5230f1d388293ac2e5655.jpg";